import { referenceService } from "src/api/references/referenceService";
import { getMedcardMenus } from "src/components/shared-components/modal/add-medcard/medicalCardData";
import { ModalMenu } from "src/components/shared-components/modal/add-medcard/AddMedicalCardModal";
import { dateTimeFormatter } from "src/utils/date";
import type { MedcardRow } from "src/models/OpenedMedcars";

type TranslateFn = (key: string) => string;

export async function fetchOpenedMedcardsRows(
  patientId: string,
  patientFilterType: string,
  upn: string | undefined,
  gender: string | undefined,
  t: TranslateFn
): Promise<MedcardRow[]> {
  let response;
  if (patientFilterType === "1") {
    response = await referenceService.connectionsOfMedcard.getConnectionOfMedCard({
      pt: Number(patientId),
    });
  } else if (upn && upn !== "") {
    response = await referenceService.connectionsOfMedcard.getConnectionOfMedCard({
      upn: Number(upn),
    });
  }

  if (!response?.data || response.data.length === 0) {
    return [];
  }

  const allMedcardMenus = getMedcardMenus(t, String(patientId), undefined, gender);
  const medcardConnections = response.data;

  return medcardConnections.map((card: any) => {
    const orId = card.orid || 0;
    const matchedCard = allMedcardMenus.find((menu: ModalMenu) => String(menu.or_id) === String(orId));

    return {
      id: card.comid,
      Open: "",
      CardName: card.name,
      CardType: card.name || card.caption || "",
      Status: card.statusname,
      ReportTrackingNo: card.tracenumber,
      TransactionType: card.modifycard,
      ProcessName: card.processname,
      ProcessTime: dateTimeFormatter(card.processtime),
      RealTime: dateTimeFormatter(card.ctime),
      PullTime: dateTimeFormatter(card.ppsftime),
      SpeelingTime: dateTimeFormatter(card.ppswtime),
      AprovalTime: dateTimeFormatter(card.ppsatime),
      url: matchedCard?.url || "",
      orId: orId,
      gpdid: card.gpdid,
    };
  });
}
